module.exports = __webpack_public_path__ + "img/wendu.ed0cb749.png";